// assets/cr-rewards.js
document.addEventListener('DOMContentLoaded', function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* =========================
     Block 5 Accordion
  ========================= */
  const accItems = Array.from(document.querySelectorAll('.crp-accItem'));

  if (accItems.length) {
    const getBody = (item) => item.querySelector('.crp-accBody');

    const syncAccordionHeights = () => {
      accItems.forEach((item) => {
        const body = getBody(item);
        if (!body) return;
        body.style.setProperty('--acc-body-h', `${body.scrollHeight}px`);
      });
    };

    const openItem = (item) => item.classList.add('is-open');
    const closeItem = (item) => item.classList.remove('is-open');

    accItems.forEach((item) => {
      const body = getBody(item);
      if (!body) return;

      body.classList.remove('hidden');

      const hiddenIcons = item.querySelectorAll('.crp-accIcons .hidden');
      hiddenIcons.forEach((el) => el.classList.remove('hidden'));

      closeItem(item);
    });

    syncAccordionHeights();

    accItems.forEach((item) => {
      const btn = item.querySelector('.accordion-btn');
      if (!btn) return;

      btn.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        accItems.forEach((other) => closeItem(other));
        if (!isOpen) openItem(item);

        requestAnimationFrame(syncAccordionHeights);
      });
    });

    window.addEventListener('resize', syncAccordionHeights);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncAccordionHeights).catch(() => {});
    }

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => syncAccordionHeights());
      accItems.forEach((item) => {
        const body = getBody(item);
        if (body) ro.observe(body);
      });
    }
  }

  /* =========================
     Banner reveal on load
  ========================= */
  if (!reduceMotion) {
    const bannerTitle = document.querySelector('.crp-banner__title');
    const bannerSub = document.querySelector('.crp-banner__sub');
    const bannerBtn = document.querySelector('.crp-banner__content .crp-btn');

    const bannerRevealItems = [bannerTitle, bannerSub, bannerBtn].filter(Boolean);

    bannerRevealItems.forEach((el, index) => {
      el.classList.add('crp-reveal', 'crp-reveal--up');
      el.style.transitionDelay = `${0.12 + index * 0.12}s`;
    });

    window.setTimeout(() => {
      bannerRevealItems.forEach((el) => el.classList.add('is-inview'));
    }, 80);
  } else {
    document
      .querySelectorAll('.crp-banner__title, .crp-banner__sub, .crp-banner__content .crp-btn')
      .forEach((el) => el.classList.add('is-inview'));
  }

  /* =========================
     Scroll Reveal Animations
  ========================= */
  if (!reduceMotion) {
    const addReveal = (elements, direction = 'up', staggerStep = 0.08) => {
      elements.forEach((el, index) => {
        if (!el) return;
        el.classList.add('crp-reveal', `crp-reveal--${direction}`);
        el.style.transitionDelay = `${index * staggerStep}s`;
      });
    };

    addReveal(Array.from(document.querySelectorAll('.crp-intro .crp-media')).slice(0, 1), 'left', 0);
    addReveal(Array.from(document.querySelectorAll('.crp-intro__mid')), 'up', 0);
    addReveal(Array.from(document.querySelectorAll('.crp-intro .crp-media')).slice(1), 'right', 0);

    addReveal(Array.from(document.querySelectorAll('.crp-community__head')), 'up', 0);
    addReveal(Array.from(document.querySelectorAll('.crp-icons4 .crp-iconCard')), 'up', 0.1);

    addReveal(Array.from(document.querySelectorAll('.crp-community__img')), 'left', 0);
    addReveal(Array.from(document.querySelectorAll('.crp-community__text')), 'right', 0);

    addReveal(Array.from(document.querySelectorAll('.crp-rewards .crp-h2.crp-center')), 'up', 0);
    addReveal(Array.from(document.querySelectorAll('.crp-icons5 .crp-iconCard')), 'up', 0.08);

    addReveal(
      Array.from(document.querySelectorAll('.crp-levels__left > .crp-h2, .crp-levels__left > .crp-community__sub')),
      'up',
      0.06
    );
    addReveal(Array.from(document.querySelectorAll('.crp-acc .crp-accItem')), 'up', 0.06);
    addReveal(Array.from(document.querySelectorAll('.crp-levels__right')), 'right', 0);

    addReveal(Array.from(document.querySelectorAll('.crp-cta__inner')), 'up', 0);

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    document.querySelectorAll('.crp-reveal').forEach((el) => {
      if (
        !el.classList.contains('crp-banner__title') &&
        !el.classList.contains('crp-banner__sub') &&
        !el.classList.contains('crp-btn')
      ) {
        observer.observe(el);
      }
    });
  } else {
    document.querySelectorAll(
      '.crp-intro .crp-media, .crp-intro__mid, .crp-community__head, .crp-icons4 .crp-iconCard, .crp-community__img, .crp-community__text, .crp-rewards .crp-h2.crp-center, .crp-icons5 .crp-iconCard, .crp-levels__left > .crp-h2, .crp-levels__left > .crp-community__sub, .crp-acc .crp-accItem, .crp-levels__right, .crp-cta__inner'
    ).forEach((el) => el.classList.add('is-inview'));
  }
});